import React from "react";

const PHONE = "4915560931517";
const PREFILL = "Hallo Hype Hafen, ich habe Interesse an eurer Unterstützung. Können wir kurz sprechen?";

export default function WhatsAppFab() {
  const href = `https://wa.me/${PHONE}?text=${encodeURIComponent(PREFILL)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Per WhatsApp schreiben"
      className="hh-wa-fab"
    >
      <span className="hh-wa-pulse" aria-hidden />
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        width="32"
        height="32"
        aria-hidden
      >
        <path
          fill="#fff"
          d="M16.003 5.333c-5.882 0-10.664 4.782-10.667 10.661-.001 1.88.491 3.715 1.426 5.331l-1.515 5.529 5.66-1.484a10.66 10.66 0 0 0 5.096 1.297h.005c5.881 0 10.663-4.782 10.666-10.662a10.604 10.604 0 0 0-3.123-7.546 10.602 10.602 0 0 0-7.548-3.126Zm0 19.379h-.004a8.86 8.86 0 0 1-4.514-1.236l-.324-.192-3.358.881.896-3.273-.211-.336a8.853 8.853 0 0 1-1.358-4.717c.002-4.887 3.978-8.861 8.872-8.861a8.81 8.81 0 0 1 6.27 2.6 8.811 8.811 0 0 1 2.595 6.27c-.002 4.887-3.979 8.864-8.864 8.864Zm4.86-6.638c-.266-.133-1.576-.778-1.82-.867-.244-.089-.422-.133-.6.133-.178.266-.688.866-.844 1.044-.155.178-.31.2-.577.067-.266-.134-1.124-.414-2.142-1.32-.792-.708-1.327-1.58-1.482-1.846-.155-.266-.017-.41.117-.542.12-.12.266-.31.4-.467.133-.155.178-.267.266-.444.089-.178.045-.333-.022-.467-.067-.133-.6-1.444-.821-1.977-.217-.52-.437-.45-.6-.458l-.51-.009c-.178 0-.467.066-.711.333-.245.267-.933.911-.933 2.222s.955 2.578 1.088 2.756c.133.178 1.879 2.868 4.553 4.022.636.275 1.132.439 1.519.561.638.203 1.219.174 1.679.106.512-.076 1.576-.644 1.798-1.266.222-.622.222-1.156.155-1.266-.067-.111-.244-.178-.51-.31Z"
        />
      </svg>
    </a>
  );
}
